import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { FeaturePage } from "./pages/Feature";
import { Dashboard } from "./pages/Dashboard";
import {loadConfig} from "./config"
import { SignedWalletProvider } from "./components/SignedWalletProvider";
import { ProtectedRoute } from './components/ProtectedRoute';
import { PageLayout } from './components/PageElements';
import { AuthRedirect } from './pages/AuthRedirect';
import { DeeporbMetrics } from './pages/Metrics';
import { SubscriptionPlans } from './pages/SubscriptionPlans';
import { MetricDetail } from './pages/MetricOverview';


export default function App() {

  const [config, setConfig] = useState(null);

  useEffect(() => {
    loadConfig().then((configFetched) => {
      setConfig(configFetched);
      console.log(`App config: ${JSON.stringify(configFetched)}`);
    });
  }
  , []);

  return (
    <>{config && // App.jsx
<SignedWalletProvider config={config}>
  <BrowserRouter>
    <Routes>
      {/* All routes inside this Layout will share the HeaderBar */}
      <Route element={<PageLayout config={config} />}>
        <Route path="/" element={<HomePage config={config} />} />
        <Route path="/metrics" element={<DeeporbMetrics config={config} />} />
        <Route path="/metrics/:metricName" element={<MetricDetail config={config} />} />
        <Route path="/plans" element={<SubscriptionPlans config={config} />} />
        <Route
          path="/auth/callback"
          element={
            <ProtectedRoute>
              <AuthRedirect config={config} />
            </ProtectedRoute>}
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard config={config} />
            </ProtectedRoute>}
        />
        <Route
          path="/feature/:featureId"
          element={
            <ProtectedRoute>
              <FeaturePage config={config} />
            </ProtectedRoute>}
        />
      </Route>
    </Routes>
  </BrowserRouter>
</SignedWalletProvider>}</>
  );
}

